module.exports = __webpack_public_path__ + "static/img/shop_img03@2x.268e0f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/instructions/shop_img03@2x.png
// module id = NnxQ
// module chunks = 174